import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocsFolder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m97.139 54.147-.66 40.932a5.27 5.27 0 0 1-5.262 5.179H32.471a5.263 5.263 0 0 1-5.262-5.344l.652-40.61a5.27 5.27 0 0 1 5.261-5.18H92.19a4.955 4.955 0 0 1 4.949 5.031v-.008Z"
        fill="#599F40"
      />
      <path
        d="M90.236 20.25a9.894 9.894 0 0 1 9.897 9.897H50.648a9.894 9.894 0 0 0-9.897-9.897h49.485Z"
        fill="#E2E8F0"
      />
      <path
        d="M40.751 20.25a9.894 9.894 0 0 0-9.896 9.897v59.381h49.484V30.147a9.894 9.894 0 0 1 9.897-9.897H40.75Z"
        fill="#F1F5F9"
      />
      <path
        d="M79.54 30.146c0-5.91 4.786-10.696 10.696-10.696a.8.8 0 1 1 0 1.6 9.094 9.094 0 0 0-9.097 9.096.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M41.834 30.309a2.279 2.279 0 0 1 2.26.004l.001-.001c.328.189.621.467.828.825v.002l3.481 5.987v.003a2.258 2.258 0 0 1-.828 3.088 2.28 2.28 0 0 1-3.102-.823l-.002-.004-1.517-2.614-1.512 2.606-.002.004a2.28 2.28 0 0 1-3.102.823 2.26 2.26 0 0 1-.83-3.089l.002-.003 3.48-5.98h.002l.006.003c.206-.36.5-.639.829-.828l.006-.003Zm2.052 4.884 1.97 3.393a.68.68 0 0 0 .921.245.658.658 0 0 0 .243-.9l-2.364-4.068-.77 1.33Zm-4.99 2.726a.66.66 0 0 0 .242.904.68.68 0 0 0 .92-.245l1.968-3.39-.769-1.327-2.362 4.058Zm3.479-5.975h-.001a.648.648 0 0 0-.04.573l.039.078.003.005.582 1.004.582-1.004a.644.644 0 0 0 .006-.647l-.006-.01-.003-.005a.655.655 0 0 0-.241-.24.681.681 0 0 0-.674.003.653.653 0 0 0-.236.237l-1.013-.58 1.002.585Z"
        fill="#78B441"
      />
      <path
        d="M72.652 68.934a.801.801 0 0 1 0 1.6H38.013a.8.8 0 0 1 0-1.6h34.64Zm0-4.948a.8.8 0 0 1 0 1.6H38.013a.8.8 0 0 1 0-1.6h34.64Zm0-4.948a.8.8 0 0 1 0 1.6H38.013a.8.8 0 1 1 0-1.6h34.64Zm0-4.949a.8.8 0 1 1 0 1.6H38.013a.8.8 0 1 1 0-1.6h34.64Zm0-4.948a.8.8 0 1 1 0 1.6H38.013a.8.8 0 0 1 0-1.6h34.64Zm0-4.95a.801.801 0 0 1 0 1.601H38.013a.8.8 0 0 1 0-1.6h34.64Zm0-4.947a.8.8 0 0 1 0 1.6H52.86a.801.801 0 0 1 0-1.6h19.793Zm0-4.949a.8.8 0 1 1 0 1.6H52.86a.8.8 0 1 1 0-1.6h19.793Zm0-4.948a.8.8 0 1 1 0 1.6H52.86a.8.8 0 1 1 0-1.6h19.793Z"
        fill="#B3C0D0"
      />
      <path
        d="M26.426 96.118a4.95 4.95 0 0 0 4.882 4.132H91.11a5.439 5.439 0 0 1-5.369-4.544l-5.287-28.421a9.894 9.894 0 0 0-9.765-8.272H49.386l-.956-5.757a4.943 4.943 0 0 0-4.883-4.14H23.951c-3.084 0-5.41 2.788-4.874 5.814l7.349 41.188Z"
        fill="#78B441"
      />
      <path
        d="M91.11 100.25H34.483c-3.356 0-5.03.396-7.018-1.831-2.136-2.268-.775-6.59 3.027-6.59H40.57c3.167 0 6.144-1.484 8.05-4.016l2.012-2.68 3.744 3.744a10.082 10.082 0 0 0 7.126 2.952h19.662c2.218 0 4.107 1.6 4.47 3.786a5.544 5.544 0 0 0 5.468 4.635h.008Z"
        fill="#599F40"
      />
      <path
        d="M43.555 48.316a5.75 5.75 0 0 1 5.672 4.8l.846 5.097h20.625c5.226 0 9.688 3.771 10.55 8.925l5.296 28.488.003.015c.434 2.635 3.082 4.429 5.87 3.603 1.89-.559 3.18-2.401 3.18-4.438a.8.8 0 0 1 1.6 0c0 2.681-1.696 5.195-4.326 5.972-3.727 1.104-7.314-1.309-7.902-4.876l-5.292-28.47-.003-.016a9.094 9.094 0 0 0-8.976-7.603H49.394a.8.8 0 0 1-.789-.669l-.956-5.765a4.15 4.15 0 0 0-4.094-3.463H27.943a.8.8 0 1 1 0-1.6h15.612ZM50.075 84.567a.8.8 0 0 1 1.13 0l5.04 5.04a.8.8 0 1 1-1.131 1.13l-5.04-5.04a.8.8 0 0 1 0-1.13Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocsFolder)
